import { ClinicalTrialList } from '@components/LoginSelections/ClinicalTrialList/ClinicalTrialList';
import { ClinicalTrialAffiliatesType } from '@dynamika-shared/types/clinicalTrialAffiliates';
import { routesPath } from '@router/routes';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useClinicalTrialAffiliatesSlice } from '@restore/clinicalTrialAffiliates/clinicalTrialAffiliates.slice';
import { useExternalUserSubjectsSlice } from '@restore/ExternalUserSubjects';
import { prepareUrl } from '@utils/routerHelpers';
import { UserRoles } from '@dynamika-shared/types/auth';

export const ExternalUserMenu = () => {
  const navigate = useNavigate();

  const [dataCT, fetchClinicalTrialAffiliates] =
    useClinicalTrialAffiliatesSlice((state, actions) => [
      state.data,
      actions.fetchClinicalTrialAffiliates,
    ]);

  const setSiteFilter = useExternalUserSubjectsSlice(
    (state, actions) => actions.setSiteFilter
  );

  useEffect(() => {
    if (!dataCT.length) {
      fetchClinicalTrialAffiliates(UserRoles.EXTERNAL_USER);
    }
  }, [dataCT]);

  const handleSelectCT = (clinicalTrial: ClinicalTrialAffiliatesType) => {
    // Reset site filter before navigating to new clinical trial
    if (setSiteFilter) {
      setSiteFilter(null);
    }
    navigate(
      prepareUrl(routesPath.externalUserSubjectsClinicalTrial, [clinicalTrial.id])
    );
  };

  return (
    <ClinicalTrialList
      clinicalTrials={dataCT}
      handleSelectCT={handleSelectCT}
      context={'menu'}
    />
  );
};
